import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "m-pageCW-card__promo" }
const _hoisted_3 = { class: "m-pageCW-card__img" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "m-pageCW-card__notification"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "button button-primary button-xs" }, "Подробнее", -1 /* HOISTED */)
const _hoisted_7 = { class: "m-pageCW-card__content" }
const _hoisted_8 = { class: "m-pageCW-card__content-head" }
const _hoisted_9 = { class: "m-pageCW-card__category" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = { class: "m-pageCW-card__content-number" }
const _hoisted_12 = { class: "m-pageCW-card__content-itemIcon m-pageCW-card__content-itemIcon_location" }
const _hoisted_13 = { class: "m-pageCW-card__content-description" }
const _hoisted_14 = { class: "m-pageCW-card__content-info" }
const _hoisted_15 = { class: "m-pageCW-card__content-date" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, " Дата начала ", -1 /* HOISTED */)
const _hoisted_17 = { class: "m-pageCW-card__content-date-start" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "m-pageCW-card__content-date" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, " Дата завершения ", -1 /* HOISTED */)
const _hoisted_21 = { class: "m-pageCW-card__content-date-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: `/construction-work/${$props.work.id}`,
    class: "m-pageCW-card"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: $props.work.image,
          alt: "`Работы ${categories[work.category].name} в районе ${work.address.name}`"
        }, null, 8 /* PROPS */, _hoisted_4),
        ($data.user && !$props.work.isRead)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5))
          : _createCommentVNode("v-if", true),
        _hoisted_6
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", {
            innerHTML: $props.categories[$props.work.category].svgContent
          }, null, 8 /* PROPS */, _hoisted_10),
          _createTextVNode(" " + _toDisplayString($props.categories[$props.work.category].name), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_11, " №" + _toDisplayString($props.work.number), 1 /* TEXT */),
        _createElementVNode("div", {
          class: "m-pageCW-card__content-status",
          style: _normalizeStyle({background: $props.statuses[$props.work.status].color})
        }, _toDisplayString($props.statuses[$props.work.status].name), 5 /* TEXT, STYLE */)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", null, _toDisplayString($props.work.address.name), 1 /* TEXT */),
          _createElementVNode("div", null, _toDisplayString($props.work.address.subtitle), 1 /* TEXT */)
        ])
      ]),
      _createElementVNode("div", _hoisted_13, _toDisplayString($props.work.description), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              ($props.work.dateStart.isHideFromUsers)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString($props.work.dateStart.dateStartForUser), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString($props.work.dateStart.dateStart), 1 /* TEXT */)
                  ], 64 /* STABLE_FRAGMENT */))
            ])
          ])
        ]),
        (!$props.work.dateEnd.hasNoExactEndDate)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  ($props.work.dateEnd.isHideFromUsers)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString($props.work.dateEnd.dateEndForUser), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString($props.work.dateEnd.dateEnd), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}